/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HandbookCategoryResponse = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        subCategory: {
    type: 'array',
    contains: {
        type: 'HandbookSubCategory',
    },
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
},
    },
};